import { toast } from './queryClient';

export const errorToast = (description: string) => {
  toast({
    title: 'Error',
    description,
    duration: 10000,
    isClosable: true,
    status: 'error',
  });
};
